export default __webpack_public_path__ + "static/media/51_mobile.42e0d1ef.jpg";